module.exports = __webpack_public_path__ + "static/img/stay-option-icon-print.00170003.svg";